import { createContext } from '@rc-component/context';
export const StaticContext = createContext(null);
export const GridContext = createContext(null);